<template>
  <div class="application">
    <div class="app-top">
      <div class="app_title">应用管理</div>
      <el-select style="width: 200px;" v-model="selectApp" placeholder="请选择" @change="AppChange">
        <el-option
          v-for="item in appList"
          :key="item.id"
          :label="item.appName"
          :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="bd_y"></div>
    <div style="padding:0 20px">
      <div class="tool">
        <div class="tool_left">
          <div class="red_g"></div>
          <div class="left_content">
            <div class="title">API调试列表</div>
            <div>
              <el-tooltip class="item" effect="dark" content="添加想要与极兔对接的接口，并通过自动联调测试。" placement="top">
                <i class="el-icon-warning-outline mal-10 cu-po"></i>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="tool_right"><el-button plain icon="el-icon-plus" @click="selectOpen">添加API</el-button></div>
      </div>
      <el-table class="table-style" :data="tableData" style="width: 100%;margin-top: 15px">
        <el-table-column prop="name" label="接口名称" width="180" align="center"></el-table-column>
        <el-table-column label="接口类型" width="100" align="center">
          <template slot-scope="{row}">
            <span>{{typeList[row.interfaceType]}}</span>
          </template>
        </el-table-column>
        <el-table-column label="接口地址" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.interfaceType === 0" class="hide-font">
              <el-tooltip class="item" effect="dark" :open-delay="500" placement="top-start">
                <span>{{scope.row.url }}</span>
                <div slot="content" style="width:300px">{{scope.row.url }}</div>
              </el-tooltip>
            </div>
            <el-input style="width:97%;margin-right:5px" v-model="scope.row.testUrl" v-else></el-input>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <span class="font-style">{{stateList[scope.row.status]}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <div style="display:inline-block" @click="showFirst(scope.row)"><span class="font-do">发起联调</span></div>
            <el-tooltip class="item" effect="dark" :open-delay="500" content="删除" placement="top">
              <i class="el-icon-delete icon-style" @click="deleteTable(scope.row.interfaceId)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class="tool mat-30">
        <div class="tool_left">
          <div class="red_g"></div>
          <div class="left_content">
            <div class="title">待上线列表</div>
            <div>
              <el-tooltip class="item" effect="dark" content="查看已经完成全部测试流程并成功上线的接口" placement="top">
                <i class="el-icon-warning-outline mal-10 cu-po"></i>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <el-table class="table-style" :data="lanchList" style="width: 100%;margin-top: 15px">
        <el-table-column prop="name" label="接口名称" width="180" align="center"></el-table-column>
        <el-table-column label="接口类型" align="center">
          <template slot-scope="{row}">
            <span>{{typeList[row.interfaceType]}}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.status === 1 ? '#E60000' : '#606266' }">{{stateList[scope.row.status]}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <span class="font-do" @click="toLine(scope.row)" v-if="scope.row.status !== 1">申请上线</span>
            <el-tooltip class="item" effect="dark" :open-delay="500" content="再次联调" placement="top">
              <i class="iconfont iconanniu-zhongxinshengchengshuju again-icon" @click="showFirst(scope.row)" v-if="scope.row.status !== 1"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class="tool mat-30">
        <div class="tool_left">
          <div class="red_g"></div>
          <div class="left_content">
            <div class="title">已完成列表</div>
            <div>
              <el-tooltip class="item" effect="dark" content="已经通过测试的接口，可填写接口正式地址并申请上线" placement="top">
                <i class="el-icon-warning-outline mal-10 cu-po"></i>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <el-table class="table-style" :data="onlineList" style="width: 100%;margin-top: 15px">
        <el-table-column prop="name" label="接口名称" width="180" align="center"></el-table-column>
        <el-table-column prop="name" label="日调用情况" width="180" align="center">
          <template slot-scope="{row}" v-if="row.interfaceType === 0 && row.dailyRequestLimit">
            <el-tooltip effect="dark">
              <el-progress :width="60" :hidden="60" type="circle" :percentage="percentageSet(row)" :color="customColors" :format="formatPercentage"></el-progress>
              <span slot="content">
                <p>当前调用量：{{ row.currentRequestVolume }}</p>
                <p>日调用上限：{{ row.dailyRequestLimit  }}</p>
              </span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="接口类型" align="center">
          <template slot-scope="{row}">
            <span>{{typeList[row.interfaceType]}}</span>
          </template>
        </el-table-column>
        <el-table-column label="接口地址" align="center">
          <template slot-scope="scope">
            <div style="display: flex;align-items: center;">
              <div class="hide-font">
                <el-tooltip class="item" effect="dark" :open-delay="500" placement="top-start">
                  <span >{{scope.row.interfaceType === 1 ? scope.row.urlCallback : scope.row.url}}</span>
                  <div slot="content" style="width:300px">{{scope.row.interfaceType === 1 ? scope.row.urlCallback : scope.row.url}}</div>
                </el-tooltip>
              </div>
              <div style="margin-left:10px;" v-if="scope.row.interfaceType === 1">
                <el-tooltip class="item" effect="dark" :open-delay="500" content="编辑" placement="top">
                  <i class="el-icon-edit cr_red" @click="toLine(scope.row)"></i>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <span>{{stateList[scope.row.status]}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :open-delay="500" content="再次联调" placement="top">
              <i class="iconfont iconanniu-zhongxinshengchengshuju again-icon" @click="showFirst(scope.row)"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" :open-delay="500" content="申请提高上限" placement="top" v-if="scope.row.interfaceType === 0">
              <i class="iconfont iconteshu-shijian again-icon" @click="upLimitApply(scope.row)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <SelectApi ref="selectApi" @refreshTable="getManagementList"/>
    <EditUrl ref="editUrl" @editApiUrl="editApiUrl"/>
    <LianTiao ref="liantiao" @selectApiClose="getManagementList"/>
    <el-dialog title="接口信息" class="editData" :visible.sync="dialogVisible" width="35%" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form label-position="top" :model="editFormData" ref="editData" :rules="editFormDataRule">
        <el-row :gutter="15">
          <el-col :span="8">
            <el-form-item label="API名称：">
              {{editFormData.name}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="说明：">
              <p style="line-height:20px">{{editFormData.detail}}</p>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="URL：" prop='urlCallback'>
              <el-input v-model.trim="editFormData.urlCallback" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">返回</el-button>
        <el-button style="color: #FFFFFF !important;" type="primary" @click.native="save">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="onlineTitle" :visible.sync="onlineApplyVisible" :close-on-click-modal="false" class="online-apply-dialog">
      <div class="messagge-info" v-html="onlineMsg">
        
      </div>
      <div>
        <span>日调用上限：</span>
        <el-input v-model="onlineApplyForm.dailyRequestLimit" :maxlength="9" @keyup.native="onlineApplyForm.dailyRequestLimit = onlyNumber(onlineApplyForm.dailyRequestLimit)"></el-input>
        <span> = {{ dailyRequestLimit }}</span>
      </div>
      <span slot="footer">
        <el-button size="small" @click="onlineApplyVisible = false">取消</el-button>
        <el-button size="small" style="color: #FFF !important;" type="primary" @click="commitApplyInfo">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import SelectApi from './selectApi.vue'
import EditUrl from './editUrl.vue'
import LianTiao from './lianTiao.vue'
import { RESPONSE_SUCCESS } from '@/constants'
import { mapGetters } from 'vuex'
import { RULES } from '@/constants/rules'
export default {
  name: 'Application',
  components: { SelectApi, EditUrl, LianTiao },
  data() {
    return {
      typeList: { 0: '订阅类', 1: '注册类' },
      stateList: { 0: '未联调', 1: '审核中', 2: '已上线', 3: '已下线', 4: '待申请', 5: '审核不通过' },
      tableData: [],
      lanchList: [],
      onlineList: [],
      selectApp: '',
      appList: [],
      dialogVisible: false,
      editFormData: {},
      editFormDataRule:{
        urlCallback:[{ required: true, message: '请输入URL', trigger: 'blur' }, RULES.url]
      },
      auditStatus: 1, // 状态值为 (0,"已提交"),(1,"未认证"),(2,"已认证"),(3,"禁用");
      onlineApplyVisible: false,
      onlineApplyForm: {
        dailyRequestLimit: ''
      },
      dailyRequestLimit: '',
      onlineTitle: '',
      customColors: [
        {color: '#67C23A', percentage: 80},
        {color: '#E6A23C', percentage: 99.9},
        {color: '#e60000', percentage: 100}
      ],
      onlineMsg: ''
    }
  },
  async mounted() {
    await this.getAppList()
    this.getManagementList()
    this.isAuth()
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    formatPercentage(percentage) {
      return percentage > 999 ? '999+%' : `${percentage}%`
    },
    percentageSet(row) {
      const { dailyRequestLimit, currentRequestVolume = 0 } = row
      if (dailyRequestLimit) {
        const num = Number((currentRequestVolume / dailyRequestLimit * 100).toFixed(2))
        return num
      }
      return 0
    },
    onlyNumber(item) {
      if (item) {
        const item1 = item.replace(/[^\d]/g, '')
        const reg = new RegExp('([0]*)([1-9]+[0-9]+)', 'g')
        const item2 = item1.replace(reg, '$2')
        console.log(item2)
        switch (item2.length) {
          case 4:
            this.dailyRequestLimit = item2.substring(0,1) + '千'
            break;
          case 5:
            this.dailyRequestLimit = item2.substring(0,1) + '万'
            break;
          case 6:
            this.dailyRequestLimit = item2.substring(0,1) + '十万'
            break;
          case 7:
            this.dailyRequestLimit = item2.substring(0,1) + '百万'
            break;
          case 8:
            this.dailyRequestLimit = item2.substring(0,1) + '千万'
            break;
          case 9:
            this.dailyRequestLimit = item2.substring(0,1) + '亿'
            break;
          default:
            this.dailyRequestLimit = item2
            break;
        }
        return item1
      } else {
        this.dailyRequestLimit = ''
      }
    },
    /**
     * @description 切换应用
     */
    AppChange(val) {
      this.getManagementList(val)
    },
    /**
     * @description 应用列表数据
     */
    async getAppList() {
      const { code, data, msg } = await this.$API.appList()
      if (code === RESPONSE_SUCCESS) {
        this.appList = data
        this.selectApp = data[0].id
      } else {
        this.appList = []
        this.$message.error(msg)
      }
    },
    /**
     * @description 调试列表数据
     */
    async getManagementList(appId) {
      const formData = new FormData()
      formData.append('appId', appId ? appId : this.selectApp)
      const { code, data, msg } = await this.$API.managementList(formData)
      if (code === RESPONSE_SUCCESS) {
        this.tableData = data.debugList
        this.lanchList = data.waitingList
        this.onlineList = data.completedList
        this.tableData.forEach(v => v.url && v.interfaceType === 0 ? v.url = 'https://uat-openapi.jtexpress.com.cn' + v.url : v.url = '')
        this.lanchList.forEach(v => v.url && v.interfaceType === 0 ? v.url = 'https://uat-openapi.jtexpress.com.cn' + v.url : v.url = '')
        this.onlineList.forEach(v => v.url && v.interfaceType === 0 ? v.url = 'https://uat-openapi.jtexpress.com.cn' + v.url : v.url = '')
      } else {
        this.$message.error(msg)
        this.tableData = []
        this.lanchList = []
        this.onlineList = []
      }
    },
    inputFous(index) {
      this.tableData[index].isInput = false
    },
    cellClick(index) {
      this.tableData[index].isInput = true
    },
    deleteTable(id) {
      this.$confirm('你确定要将其从应用调试列表删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.removeInterface(id)
      }).catch(() => {});
    },
    /**
     * @description 移除接口
     */
    async removeInterface(id) {
      const { code, msg } = await this.$API.removeInterface({ id, appId: this.selectApp })
      if (code === RESPONSE_SUCCESS) {
        this.$message.success('删除成功')
        this.getManagementList()
      } else {
        this.$message.error(msg)
      }
    },
    // 申请提高限制
    upLimitApply(row) {
      this.onlineApplyVisible = true
      this.onlineApplyForm = JSON.parse(JSON.stringify(row))
      if (this.onlineApplyForm.dailyRequestLimit) {
        this.onlineApplyForm.dailyRequestLimit = this.onlyNumber(row.dailyRequestLimit.toString())
      } else {
        this.dailyRequestLimit = ''
      }
      this.onlineTitle = '调用上限申请'
      this.onlineMsg = '请填写接口日调用最大限制'
    },
    toLine(row) { // 申请上线
      if (row.interfaceType === 1) {
        this.editFormData = row
        this.dialogVisible = true
      } else if (row.interfaceType === 0) {
        this.onlineApplyVisible = true
        this.onlineApplyForm = JSON.parse(JSON.stringify(row))
        this.onlineApplyForm.dailyRequestLimit = '20000'
        this.dailyRequestLimit = '2万'
        this.onlineMsg = `<i class="el-icon-warning" style="color: #e6a23c; font-size: 24px;"></i><span style="margin-left: 10px">请确定是否将${this.onlineApplyForm.name}接口申请上线？</span>`
        this.onlineTitle = '上线申请'
      } else {
        this.$confirm(`请确定是否将${row.name}接口申请上线？`, '上线申请', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.applySubmit({ id: row.id, userId: this.user.id, status: 1 })
        })
      }
    },
    commitApplyInfo() {
      const { id, dailyRequestLimit } = this.onlineApplyForm
      if (!dailyRequestLimit) {
        this.$message.warning('请输入调用上限')
        return
      }
      if (this.onlineTitle === '上线申请') {
        this.applySubmit({ id, userId: this.user.id, status: 1, dailyRequestLimit })
      } else if (this.onlineTitle === '调用上限申请') {
        // 修改上线申请接口
        this.$API.applyLimit({ id, afterLimitNumber: dailyRequestLimit}).then(res => {
          if (res.code === RESPONSE_SUCCESS) {
            this.$message.success("保存成功")
            this.dialogVisible = false
            this.onlineApplyVisible = false
            this.getManagementList()
          } else {
            this.$message.error(res.msg)
          }
        }).catch(err=>{
          if (err.msg) {
            this.$message.error(err.msg)
          } else {
            this.$message.error('网络繁忙，请重试')
          }
        })

      }
    },
    /**
    * 弹出层保存
    */
    save(){
      this.$refs['editData'].validate((valid) => {
          if (valid) {
          this.applySubmit({ id:this.editFormData.id, userId: this.user.id,urlCallback:this.editFormData.urlCallback,status: 1})
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    /**
     * 申请提交
     **/
    applySubmit(param){
      if(param.status == 0 || param.status == 3){
        //申请 停用时 
        param.status = 1;//申请中
      }
      this.$API.apply(param).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          this.$message.success("保存成功")
          this.dialogVisible = false
          this.onlineApplyVisible = false
          this.getManagementList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err=>{
        if (err.msg) {
          this.$message.error(err.msg)
        } else {
          this.$message.error('网络繁忙，请重试')
        }
      })
    },
    selectOpen() {
      this.$refs.selectApi.init(this.selectApp)
    },
    showEdit(row, index) {
      this.$refs.editUrl.init({ url: row.urlCallback, index })
    },
    editApiUrl(info) {
      const { url, index } = info
      this.onlineList[index].url = url
    },
    showFirst(row) {
      if (this.auditStatus !== 2) return this.$message.error('请先完成认证！')
      if (row.interfaceType === 1 && row.testUrl) {
        this.$refs.liantiao.init({ ...row, pid: this.selectApp })
      } else if (row.interfaceType === 0 && row.url) {
        this.$refs.liantiao.init({ ...row, pid: this.selectApp })
      } else {
        this.$message.warning('接口地址不能为空！')
      }
    },
    /**
     * @description 判断是否认证
     */
    isAuth() {
      this.$API.getCertificationInfo().then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          this.auditStatus = res.data.auditStatus
          // 这里需要判断是否认证通过，认证通过，并且uuid为空，即需要保存
          if(res.data.auditStatus == 2 && this.uuid.length == 0) {
            this.SET_UUID(res.data.uuid)
          }
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
  .application {
    padding: 0 0 30px 0;
    .app-top {
      display: flex;
      align-items: center;
      padding: 15px 0;
      ::v-deep.el-input {
        width: 200px !important;
      }
    }
    .app_title {
      font-size: 18px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      color: #2b2b2b;
      margin: 0 20px 0 30px;
    }
    .bd_y {
      // width: 947px;
      height: 1px;
      background: #D9D9D9;
      margin-bottom: 22px;
    }
    .tool {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .tool_left {
        display: flex;
        align-items: center;
        .red_g {
          width: 3px;
          height: 18px;
          background: #e60000;
          margin-right: 10px;
        }
        .left_content {
          display: flex;
          align-items: center;
          .title {
            font-size: 18px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 700;
            color: #2b2b2b;
          }
          .cu-po {
            cursor: pointer;
          }
        }
      }
    }
    .table-style {
      :deep() svg > path:nth-child(2) {
        stroke: url(#write);
      }
      ::v-deep .el-progress__text {
        font-size: 12px !important;
      }
      .font-style {
        color: #FF8909;
      }
      .font-do {
        color: #E60000;
        margin-right: 10px;
      }
      .font-do:hover {
        text-decoration:underline;
      }
      .font-do,
      .icon-style {
        cursor: pointer;
      }
      .icon-style {
        font-size: 16px;
      }
      .icon-style:hover {
        color: #E60000;
      }
      .hide-font {
        width: 95%;
        margin-right:5px;
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
      }
    }
  }
  .mal-10 {
    margin-left: 10px;
  }
  .dis-flex {
    display: flex;
    align-items: center;
  }
  .cr_red {
    color: #E60000;
    font-size: 16px;
    cursor: pointer;
  }
  .mat-30 {
    margin-top: 30px;
  }
</style>
<style lang="scss" scoped>
.online-apply-dialog {
  ::v-deep .el-dialog__body {
    padding-top: 0;
  }
  .messagge-info {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    span {
      margin-left: 12px;
    }
    .el-icon-warning {
      color: #e6a23c;
      font-size: 24px;
    }
  }
  .el-input {
    width: 150px;
  }
}
  ::v-deep .el-button.is-plain:hover, .el-button.is-plain:focus {
    color: #FFFFFF !important;
    background-color: #E60000 !important;
  }
  .el-button {
    border-color: #E60000 !important;
    color: #E60000 !important;
  }
  .editData::v-deep{
  .el-dialog{
    border-radius: 10px;
  }
  .el-form-item .el-form-item__label {
    color: #9499A3;
    padding: 0;
    line-height: 24px
  }
}
  ::v-deep .el-table th {
    background-color: #F2F2F2 !important;
  }
  .again-icon {
    font-size: 16px;
    display: inline-block;
    margin-left: 5px;
  }
  .again-icon:hover {
    color: #E60000;
    cursor: pointer;
  }
</style>

